"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var ramda_1 = require("ramda");
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("..");
var __2 = require("../../../..");
var hooks_1 = require("../../../../hooks");
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var BulbIcon_1 = __importDefault(require("../../../Icon/BulbIcon"));
var Obor_1 = __importDefault(require("./Obor"));
var utils_1 = require("./utils");
var H2 = styled_components_1.default.h2(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 140%;\n  color: #000000;\n  margin-top: 0;\n"], ["\n  font-style: normal;\n  font-weight: normal;\n  font-size: 28px;\n  line-height: 140%;\n  color: #000000;\n  margin-top: 0;\n"])));
var PridatObor = styled_components_1.default(LinkButton_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 16px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n"], ["\n  font-size: 16px;\n  line-height: 22px;\n  text-decoration-line: underline;\n  color: #2362a2;\n"])));
var StyledInfoDiv = styled_components_1.default(__1.InfoDiv)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 10px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #333333;\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 10px 36px 10px 20px;\n  font-size: 15px;\n  line-height: 24px;\n  letter-spacing: 0.0125em;\n  color: #333333;\n  ",
    "\n"])), function (_a) {
    var $error = _a.$error;
    return $error && styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      border: 1px solid red;\n    "], ["\n      border: 1px solid red;\n    "])));
});
var SpecializaceField = function (_a) {
    var name = _a.name, label = _a.label, disableAdd = _a.disableAdd, seekObor = _a.seekObor, placeHolder = _a.placeHolder, specializaceFilter = _a.specializaceFilter, onRemoveAny = _a.onRemoveAny, prioritni = _a.prioritni, readOnly = _a.readOnly, isSpecializaceLoad = _a.isSpecializaceLoad;
    var _b = hooks_1.useCiselnik('specializaceVcetneNeplatnych'), load = _b.loading, error = _b.error, data = _b.data;
    var _c = formik_1.useField(name), field = _c[0], meta = _c[1], helpers = _c[2];
    var cache = __2.useCache();
    var loading = hooks_1.useBoolean(false);
    var _d = react_1.useState(), prioritniSpec = _d[0], setPrioritniSpec = _d[1];
    var prioritniGET = hooks_1.useGetJSON((cache === null || cache === void 0 ? void 0 : cache.read('appConfig').ZNALCI_API) + "ZnalecSpecializace");
    var _e = react_1.useState(), initialSpecs = _e[0], setInitialSpecs = _e[1];
    var initialIds = utils_1.getTreeIds(initialSpecs);
    var filterSpecializace = function (values) {
        var filteredData = values === null || values === void 0 ? void 0 : values.map(function (o) {
            var _a, _b;
            return (__assign(__assign({}, o), { podrizene: (_b = (_a = o.podrizene) === null || _a === void 0 ? void 0 : _a.map(function (odvetvi) { return (__assign(__assign({}, odvetvi), { podrizene: odvetvi === null || odvetvi === void 0 ? void 0 : odvetvi.podrizene.filter(function (sp) { return initialIds.includes(sp.idSpecializace) || !sp.platnostDo || (sp.platnostDo && new Date(sp.platnostDo) > new Date()); }) })); })) === null || _b === void 0 ? void 0 : _b.filter(function (odv) { return initialIds.includes(odv.idSpecializace) || !odv.platnostDo || (odv.platnostDo && new Date(odv.platnostDo) > new Date()); }) }));
        }).filter(function (obor) { return initialIds.includes(obor.idSpecializace) || !obor.platnostDo || (obor.platnostDo && new Date(obor.platnostDo) > new Date()); });
        return filteredData;
    };
    var specializace = filterSpecializace(prioritniSpec || data);
    react_1.useEffect(function () {
        var _a;
        var loadPrioritni = function () { return __awaiter(void 0, void 0, void 0, function () {
            var params, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        loading.setTrue();
                        params = {
                            idZnalec: prioritni,
                        };
                        return [4 /*yield*/, prioritniGET(params)];
                    case 1:
                        result = _a.sent();
                        loading.setFalse();
                        if (__2.isRight(result)) {
                            setPrioritniSpec(result.value);
                        }
                        return [2 /*return*/];
                }
            });
        }); };
        if ((_a = prioritni === null || prioritni === void 0 ? void 0 : prioritni.filter(function (p) { return p !== 0; })) === null || _a === void 0 ? void 0 : _a.length)
            loadPrioritni();
        else
            setPrioritniSpec(prioritni ? [] : undefined);
    }, [prioritni === null || prioritni === void 0 ? void 0 : prioritni.length, prioritni === null || prioritni === void 0 ? void 0 : prioritni.includes(0)]);
    var value = field.value || [];
    react_1.useEffect(function () {
        setInitialSpecs(value);
    }, []);
    if ((!specializace && (load || loading.value)) || isSpecializaceLoad) {
        return react_1.default.createElement(react_1.default.Fragment, null, "na\u010D\u00EDt\u00E1n\u00ED");
    }
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, error);
    }
    var handleChangeObor = function (index) { return function (obor) {
        helpers.setValue(ramda_1.set(ramda_1.lensIndex(index), obor, value));
    }; };
    var handleAddObor = function () {
        helpers.setValue(ramda_1.append({}, value));
    };
    var handleRemoveAny = function (idSpecializace) {
        var spec = __1.getSpecializaceById(idSpecializace, specializace || []);
        if (spec) {
            var podrazeneRemoved = utils_1.getTreeIds([spec]);
            if (onRemoveAny)
                onRemoveAny(podrazeneRemoved);
        }
    };
    var handleRemoveObor = function (index) { return function () {
        handleRemoveAny(value[index].idSpecializace);
        helpers.setValue(ramda_1.remove(index, 1, value));
    }; };
    var getPovoleneSpecializace = function () {
        var obory = specializaceFilter.map(function (o) { return o.idSpecializace; }).flat(2);
        return obory.map(function (o) { return utils_1.getNadrazeneIds(o, specializace || []); }).flat();
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(H2, null, label),
        ramda_1.addIndex(ramda_1.map)(function (obor, index) { return (react_1.default.createElement(Obor_1.default
        // eslint-disable-next-line react/no-array-index-key
        , { 
            // eslint-disable-next-line react/no-array-index-key
            key: obor.idSpecializace || "create-" + index, seek: seekObor, onChange: handleChangeObor(index), onRemove: handleRemoveObor(index), onRemoveAny: handleRemoveAny, obor: obor, specializace: specializace || [], value: field.value, disableAdd: disableAdd, placeHolder: placeHolder, specializaceFilter: specializaceFilter && getPovoleneSpecializace(), prioritni: prioritni, readOnly: readOnly, initialSpecs: initialIds })); }, value),
        !value ||
            (!value.length && (react_1.default.createElement(StyledInfoDiv, { "$error": !!meta.error },
                react_1.default.createElement(BulbIcon_1.default, null),
                "Osoba nem\u00E1 p\u0159id\u011Bleny \u017E\u00E1dn\u00E9 obory a specializace."))),
        !utils_1.isAddDisabled(disableAdd, 'obor') && !readOnly && (react_1.default.createElement(PridatObor, { type: "button", onClick: handleAddObor, name: "PridatObor" }, "+ P\u0159idat obor"))));
};
SpecializaceField.defaultProps = {
    disableAdd: false,
    seekObor: false,
    placeHolder: undefined,
    specializaceFilter: undefined,
    onRemoveAny: undefined,
    prioritni: undefined,
    readOnly: undefined,
    isSpecializaceLoad: undefined,
};
exports.default = SpecializaceField;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
